import {Field} from "@mytour/ui/form";
import {Splitter} from "@mytour/ui/layout";
import type {UseFormReturn} from "react-hook-form";
import z from "zod";
export const step2Schema = z.object({
  address: z.string().trim().min(3, {message: "Obligatoire"}),
  city: z.string().trim().min(3, {message: "Obligatoire"}),
  zip: z
    .string()
    .trim()
    .regex(/^\d{5}$/, "Le code postal doit contenir 5 chiffres"),
});
export type Step2Form = z.infer<typeof step2Schema>;

type Props = {
  hookForm: UseFormReturn<Step2Form>;
  disabled: boolean;
};

export function Step2({hookForm, disabled}: Props) {
  return (
    <>
      <p style={{marginBottom: "8px"}}>
        <strong>Le siège social</strong>
      </p>
      <Field required name="address" hookForm={hookForm} disabled={disabled} />
      <Splitter>
        <Field required name="zip" hookForm={hookForm} disabled={disabled} />
        <Field required name="city" hookForm={hookForm} disabled={disabled} />
      </Splitter>
    </>
  );
}
